// US phone numbers for MDxS-MedUsers.Phone (build plan §6.1 addendum,
// 2026-10-14). Pure, no imports: the server normalizes with it and the SPA
// formats with it, so both read the stored form the same way.
//
// Stored form: "+1" and 10 digits ("+14105551234"), or "" for no phone.
// Input may use the common forms (dashes, spaces, dots, parentheses, a leading
// 1 or +1). Anything else is refused rather than guessed at: letters, an
// extension, too few or too many digits, or an area code or exchange starting
// with 0 or 1 (never valid in the North American plan).

export type PhoneResult = { ok: true; value: string } | { ok: false };

export const MSG_PHONE_INVALID = "Enter a 10-digit US phone number, like (410) 555-0123.";

const NANP = /^[2-9]\d{2}[2-9]\d{6}$/;

/** Normalizes user input to "+1XXXXXXXXXX", "" for blank, or refuses it. */
export function normalizePhone(raw: unknown): PhoneResult {
  if (typeof raw !== "string") return { ok: false };
  const t = raw.trim();
  if (!t) return { ok: true, value: "" };
  if (!/^\+?[\d\s().-]+$/.test(t)) return { ok: false };
  let digits = t.replace(/\D/g, "");
  if (t.startsWith("+") && !digits.startsWith("1")) return { ok: false };
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  if (!NANP.test(digits)) return { ok: false };
  return { ok: true, value: `+1${digits}` };
}

/**
 * "(410) 555-0123" for a stored "+14105550123". A value not in the stored
 * form (typed into SharePoint by hand) is shown as it is; "" stays "".
 */
export function formatPhone(stored: string): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(stored);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : stored;
}
